import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=2be98238&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"
import style0 from "./ThankYouPage.vue?vue&type=style&index=0&id=2be98238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be98238",
  null
  
)

export default component.exports